<template>
  <div class="container-fluid">
    <h5
        class="py-2"
        style="user-select: none"
    >
      {{$t('message.editStatusByDriver')}}
    </h5>
    <div class="my-2">
      <div class="fs-4 d-flex align-items-center justify-content-between border-1 border-bottom border-dark pb-1">
        <span>
          {{$t('manager.labelName')}}
        </span>

        <b v-if="items.manager">
          {{items.manager.full_name}}
        </b>
      </div>

      <div class="fs-4 d-flex align-items-center justify-content-between border-1 border-bottom border-dark pb-1">
        <span>
          {{$t('modal.form.roundName')}}
        </span>

        <b>
          {{items.name}}
        </b>
      </div>

      <div class="fs-4 d-flex align-items-center justify-content-between border-1 border-bottom border-dark pb-1">
        <span>
          {{$t('modal.form.data')}}
        </span>

        <b>
          {{items.created_at | DayStartDate(items.created_at)}}
        </b>
      </div>

      <div class="fs-4 d-flex align-items-center justify-content-between border-1 border-bottom border-dark pb-1">
        <span>
          {{$t('modal.form.hour')}}
        </span>

        <b>
          {{items.created_at | Hour_UTF(items.created_at)}}
        </b>
      </div>

      <div
        v-for="(product, index) in items.products"
        :key="index"
      >
        <div class="fs-4 d-flex align-items-center justify-content-between border-1 border-bottom border-dark pb-1">
          <span>
            {{$t('modal.form.product.label')}}
          </span>

          <b>
            {{product.name}}
          </b>
        </div>

        <div class="fs-4 d-flex align-items-center justify-content-between border-1 border-bottom border-dark pb-1">
        <span>
          {{$t('modal.form.quantity.label')}}
        </span>

        <b>
          {{product.pivot.quantity}}
        </b>
      </div>
      </div>
    </div>

    <b-button
        class="float-end ms-3"
      variant="success"
      @click="handleAccept"
        :disabled="db"
    >
      {{$t('modal.button.accept')}}
    </b-button>

    <b-button
        class="float-end ms-3"
        variant="danger"
        @click="handleReject"
        :disabled="db"
    >
      {{$t('modal.button.reject')}}
    </b-button>

    <b-button
      class="float-end"
      variant="warning"
      @click="handleClose"
    >
      {{$t('modal.button.back')}}
    </b-button>
  </div>
</template>

<script>
  import {updateDriverWaterRound, showDriverWaterRound} from '../../../../api/endpoints/driverWaterRounds'

  export default {
    name: "DriverWaterRounds-ActionModal",
    props: {
      id: {
        type: Number,
        required: true
      },
    },
    data() {
      return {
        fields: [
          {key: "name", label: this.$t('table.name.label')},
          {key: "pivot.quantity", label: this.$t('table.quantity.label')},
        ],
        items: {},
        db:false,
      }
    },
    methods: {
      handleAccept() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        updateDriverWaterRound({id: this.id,status: 2}).then( () => {
          this.handleClose();
        })
      },
      handleReject() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        updateDriverWaterRound({id: this.id, status: 3}).then( () => {
          this.handleClose();
        })
      },
      handleClose() {
        this.$emit('onClose')
      },
      getProductsOptions() {
        showDriverWaterRound(this.id).then( res => {
          // eslint-disable-next-line no-console
          console.log(res.data)
        this.items = res.data
      })
      },
      getHours(str) {
        let _str = str
        let  index = _str.indexOf('T');
        let _a = _str.slice(index, 5)
        // eslint-disable-next-line no-console
        console.log(_a);
      }
    },
    mounted() {
      this.getProductsOptions();
    }

  }
</script>

<style scoped>

</style>
